export default {
      id: "icon-arrow-right-usage",
      viewBox: "0 0 19.11 18.239",
      url: __webpack_public_path__ + "img/icons.33fd9142.svg#icon-arrow-right",
      toString: function () {
        return this.url;
      }
    }